import { computed } from 'vue'

import { useUserStore } from '@/store/user-store/user-store'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'

export const useUserInfoLoaded = () => {
    const userStore = useUserStore()
    const isMounted = useIsMounted()

    const infoLoaded = computed(() => {
        if (userStore.hasAuthToken) {
            return isMounted.value && userStore._isUserInfoLoaded
        }
        return true
    })
    return infoLoaded
}
